/** @jsx React.DOM */

var React = require('react');
var _ = require('lodash');

var Pagination = React.createClass({displayName: 'Pagination',
  render: function() {
    return (
      React.DOM.p(null, 
        'Pages: ', 
        React.DOM.a({href: "#", onClick: this.handlePrevious}, "Previous"), 
        React.DOM.span(null, " - "), 
        React.DOM.a({href: "#", onClick: this.handleNext}, "Next")
      )
    );
  },

  handlePrevious: function(e) {
    e.preventDefault();
    this.shiftData(-20);
  },

  handleNext: function(e) {
    e.preventDefault();
    this.shiftData(+20);
  },

  shiftData: function(step) {
    var currentDomain = this.props.appState.domain.x;
    var newDomain = _.map(currentDomain, function(x) {
      return x + step;
    });
    this.props.setAppState({
      data: this.props.getData(newDomain),
      domain: _.assign({}, this.props.appState.domain, {
        x: newDomain
      }),
      tooltips: [],
      prevDomain: this.props.appState.domain
    });
  }
});

module.exports = Pagination;



/*****************
 ** WEBPACK FOOTER
 ** ./src/Pagination.js
 ** module id = 3
 ** module chunks = 0
 **/